
export default {
  name: 'RightMenuBar',
  data() {
    return {
      visible: false,
      position: { x: 0, y: 0 },
      ownerList: [],
    }
  },
  methods: {
    show(options) {
      this.position = {
        x: options.event.clientX,
        y: options.event.clientY,
      }
      this.list = options.list
      this.ownerList = options.ownerList
      this.visible = true
      document.addEventListener('click', this.hide)
      document.addEventListener('contextmenu', this.hide)
    },
    hide() {
      this.visible = false
      document.removeEventListener('click', this.hide)
      document.removeEventListener('contextmenu', this.hide)
    },
    handleItemClick(item) {
      if (item.disabled) return
      this.$bus.$emit(item.type, this.ownerList)
      this.hide()
    },
  },
}
